import { Divider, Steps } from "antd";
import React, { useState } from "react";
import close from "../../assets/icons/close.png";
import success_gif from "../../assets/icons/success_gif.gif";

import AmountNTenure from "./AmountNTenure";
import SelectPayment from "./SelectPayment";
import AdditionalInfo from "./AdditionalInfo";
import Review from "./Review";
import DepositSummary from "./DepositSummary";
import VerifyDetails from "./VerifyDetails";

const FDForm = ({ cb, setOpenAddNew }) => {
  const [currentStep, setCurrentStep] = useState(0);

  const next = () => {
    setCurrentStep(currentStep + 1);
  };

  const prev = () => {
    setCurrentStep(currentStep - 1);
  };
  const steps = [
    {
      title: "Amount & Tenure",
      content: (
        <AmountNTenure
          next={next}
          cancel={() => {
            setOpenAddNew(false);
          }}
        />
      ),
    },
    {
      title: "Verify Details",
      content: (
        <VerifyDetails
          next={next}
          back={prev}
          cancel={() => {
            setOpenAddNew(false);
          }}
        />
      ),
    },
    {
      title: "Additional info",
      content: <AdditionalInfo next={next} back={prev} />,
    },
    {
      title: "Select Payment",
      content: <SelectPayment next={next} back={prev} />,
    },
    {
      title: "Review & Confirm",
      content: <Review next={next} back={prev} />,
    },
  ];

  return (
    <div className="upload_payment_parent send-payment fd-form">
      <div className="flex-between sec-head">
        <div className="tabsSection">
          <span className="active">Fixed Deposit</span>
        </div>
        <img
          src={close}
          width={20}
          onClick={() => {
            setOpenAddNew(false);
            cb?.();
          }}
        />
      </div>
      <div className="hr" />
      <div className="p2">
        <Steps current={currentStep}>
          {steps.map((item, index) => (
            <Steps.Step key={index} title={item.title} />
          ))}
        </Steps>

        <div className="steps-content" style={{ marginTop: 20 }}>
          {currentStep <= 4 ? (
            steps[currentStep].content
          ) : (
            <div className="success_section w100">
              <div className="success_container d-flex-center flex-col ">
                <div className="image_section mb2">
                  <img src={success_gif} alt="success page icon" />
                </div>
                <div className="application">
                  <h4>Congratulations!</h4>
                </div>
                <div
                  className="application_note text-center"
                  style={{
                    maxWidth: 700,
                  }}
                >
                  <span>
                    Thank you for choosing our Bank. Your FD has been booked
                    succesfully You will receive a digital FD certificate in 3
                    Business working days
                  </span>
                </div>
                <div className="button_section mt3">
                  <button className="back-btn">View Details</button>
                </div>
              </div>
            </div>
          )}

          {currentStep <= 2 && (
            <>
              <Divider type="vertical" />
              {/* <DepositSummary /> */}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default FDForm;
